module.exports = __webpack_public_path__ + "media/src/images/professor_bg-824bbe8d0ab0d92afd9e3e3cfb3a8541.jpg";